import { Component, OnInit} from '@angular/core';
import { Driver } from 'src/app/models/driver';
import { DriverService } from 'src/app/services/driver.service';
import { NgbModal, NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';
import { DriverPlants } from 'src/app/driver-plants';
import { Plants } from 'src/app/models/plants';
import * as _ from 'lodash';

@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class DriverComponent implements OnInit {
  public drivers:Driver[] = [];
  public driversTemp:Driver[] = [];
  public loading = false;
  public driver:Driver = new Driver() ;
  public minDate = {year: 1950, month: 1, day: 1};
  public maxDate = {year: (new Date()).getFullYear(), month: 12, day: 31};
  public expand:boolean = false;

  public actEditDriv:boolean = true;
  public actAddDriv:boolean = true;
  public actDeleteDriv:boolean = true;
  
  public filterStatus:string = 'all';
  public filterName:string = '';

  public totalDrivers:number = 0;
  public activeDrivers:number = 0;
  public inActiveDrivers:number = 0;

  //Pagination
  public page:number = 1;
  public pagination:number = 10;
  //Plantas
  public plants: Plants[] = []; //Catalogo
  public plantOper: Plants[] = []; //Plantas Usuario
  public plantMaps: any[] = [];
  //public plantId: number = 1; //Id Planta

  constructor(private driverServ:DriverService, private modalService: NgbModal, private utl:UtilitiesService, private authService:AuthService, private toastr: ToastrManager) { }

  ngOnInit() {
    this.getDrivers();
    this.getPlants();
    this.actEditDriv = this.authService.can("update-driver");
    this.actDeleteDriv = this.authService.can("destroy-driver");
    this.actAddDriv = this.authService.can("store-driver");
  }

  getDrivers() {
    this.loading = true;
    this.driverServ.getDrivers().then( response => {
      this.drivers = response;
      this.driversTemp = this.drivers;
      this.getStatistics();
      this.loading = false;
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  getPlants(){
    this.driverServ.getAllPlants().then(response => {
      this.plants = response;
    }, error => { this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true }); });
  }

  getStatistics(){
    this.totalDrivers = this.drivers.length;
    this.utl.filterDriverBy(this.drivers,'statistics','active',data=>this.activeDrivers=data);
    this.utl.filterDriverBy(this.drivers,'statistics','inactive',data=>this.inActiveDrivers=data);
  }

  select(modal?, driver?:Driver) {
    if(driver) {
      this.driver = driver;
      
      if(!(driver.born_date instanceof Date) && driver.born_date)
        this.driver.born_date = new Date(driver.born_date + " 10:00:00");
      if(!(driver.contracted_date instanceof Date) && driver.contracted_date)
        this.driver.contracted_date = new Date(driver.contracted_date + " 10:00:00");
      if(!(driver.licence_date instanceof Date) && driver.licence_date)
        this.driver.licence_date = new Date(driver.licence_date + " 10:00:00");
      if(!(driver.medic_date instanceof Date) && driver.medic_date)
        this.driver.medic_date = new Date(driver.medic_date + " 10:00:00");
      if(!(driver.uncontracted_date instanceof Date) && driver.uncontracted_date)
        this.driver.uncontracted_date = new Date(driver.uncontracted_date + " 10:00:00");

    } else {
      this.driver = new Driver();
    }

    if(modal) {
      this.modalService.open(modal, { size: 'lg' });
    }
  }

  async storeDriver() {
    try {      
      this.loading = true;
      await this.driverServ.postDriver(this.driver);
      await this.getDrivers();
      this.modalService.dismissAll();
      this.loading = false;
      this.toastr.successToastr('El operador se ha creado correctamente', '', { enableHTML: true });
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }
  
  async updateDriver() {
    try {
      this.loading = true;
      await this.driverServ.putDriver(this.driver);
      await this.getDrivers();
      this.modalService.dismissAll();
      this.loading = false;
      this.setFiltersDefualt();
      this.toastr.successToastr('El operador se ha actualizado correctamente');
    } catch (e) {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    }
  }

  async deleteDriver() {
    if(this.driver.uncontracted_date && this.driver.uncontracted_description){
      try {
        this.loading = true;
        await this.driverServ.deleteDriver(this.driver);
        await this.getDrivers();
        this.modalService.dismissAll();
        this.loading = false;
        this.setFiltersDefualt();
        this.toastr.successToastr('El operador se ha eliminado correctamente');
      } catch (e) {
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
      }
    }else{
      this.toastr.errorToastr("Todos los campos son obligatorios para eliminar al operador", '', { enableHTML: true});
    }
  }

  filterBy(by:string,find=''){
    if(by == 'name'){
      this.utl.filterDriverBy(this.drivers,'status',this.filterStatus,drivers=>this.driversTemp=drivers);
      this.utl.filterDriverBy(this.driversTemp,by,find,drivers=>this.driversTemp=drivers);
    }else{
      this.utl.filterDriverBy(this.drivers,by,this.filterStatus,drivers=>this.driversTemp=drivers);
    }
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/drivers?status=' + this.filterStatus.toString(),'_blank')
  }

  saveFile(f, name) {
    if (f[0]){
      this.loading = true;
      let file = f[0];     

      const formData: FormData = new FormData();
      formData.append('file', file, file.name);      
      formData.append('driver', this.driver.id.toString());      
      formData.append('name', name);      
     
      this.driverServ.postFile(formData).subscribe(x => {
        this.driver = x;
        let fileName = (name == 'licencia_manejo') ? 'La licencia de manejo' : 'El certificado médico';
        this.toastr.successToastr(fileName + " se cargo correctamente");
        this.loading = false;
      }, error =>{
        this.loading = false;
        this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
      }
      );  
    }
  }

  downloadFile(driver,file){
    this.driverServ.downloadFile(driver, file).subscribe(response=>{
      let blob:any = new Blob([response],{type: 'charset=uft-8'});
      const url = window.URL.createObjectURL(blob);
      FileSaver.saveAs(blob, file + '.pdf');
    });
  }

  async avatarSelected(message){
    this.setFiltersDefualt();
    await this.getDrivers();
    this.toastr.successToastr(message);
  }

  setFiltersDefualt(){
    this.filterStatus = 'all';
    this.filterName = '';
  }

  setPlants(modal, driver: Driver){
    this.driver = driver;
    this.mapsPlantsDriver();
    this.modalService.open(modal, { size: 'lg' });
  }

  mapsPlantsDriver(){
    let plantsTemp = [];
    _.forEach(this.driver.plants, (p) => { plantsTemp.push(p.plant_id) });
    let mapPlants = [];
    _.forEach(this.plants, (p) => {
      (plantsTemp.includes(p.id)) ? mapPlants.push({id: p.id, name: p.name, status: true}) : mapPlants.push({id: p.id, name: p.name, status: false}); 
    });
    this.plantMaps = mapPlants;
  }

  updatePlants(){
    this.loading = true;
    this.driverServ.updatePlants(this.driver.id, this.plantOper).then(response => {
      this.toastr.successToastr("La actualización de plantas se realizó correctamente!!");
      this.drivers = response;
      this.driversTemp = this.drivers;
      this.getStatistics();
      this.getPlants();
      this.modalService.dismissAll();
      this.loading = false;
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', { enableHTML: true });
    });
  }

  selectedPlant(p:any){
    //Revisamos si el ticket ya esta agregado, sino lo agregamos
    let plant = this.plants.find(pl => pl.id == p.id);
    if(!this.plantOper.find(p => p.id == plant.id)){
      this.plantOper.push(plant);
    }else{
      //Para saber en posicion esta el elemento a eliminar
      let i = this.plantOper.findIndex(p => p.id == plant.id);
      if(i !== -1 ){
        this.plantOper.splice(i, 1);
      }
    }
  }
}
